import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/Ai',
    name: 'Ai',
    component: () => import('../views/Ai/index.vue')
  },
  {
    path: '/homePage/APPdevelopment',
    name: 'APPdevelopment',
    component: () => import('../views/homePage/APPdevelopment.vue')
  },
  {
    path: '/homePage/Webconstruction',
    name: 'Webconstruction',
    component: () => import('../views/homePage/Webconstruction.vue')
  },
  {
    path: '/homePage/Wechat',
    name: 'Wechat',
    component: () => import('../views/homePage/Wechat.vue')
  },
  {
    path: '/homePage/H5',
    name: 'H5',
    component: () => import('../views/homePage/H5.vue')
  },
  {
    path: '/programme',
    name: 'Programme',
    component: () => import('../views/programme/index.vue')
  },
  {
    path: '/presentation',
    name: 'Presentation',
    component: () => import('../views/presentation/index.vue')
  },
  {
    path: '/presentation/details',
    name: 'Presentationdetails',
    component: () => import('../views/presentation/details.vue')
  },
  {
    path: '/Journalism',
    name: 'Journalism',
    component: () => import('../views/Journalism/index.vue')
  },
  {
    path: '/Journalism/details',
    name: 'Journalism/details',
    component: () => import('../views/Journalism/details.vue')
  },
  {
    path: '/AboutUS',
    name: 'AboutUS',
    component: () => import('../views/AboutUS/index.vue')
  },
  {
    path: '/AboutUS/cooperation',
    name: 'AboutUScooperation',
    component: () => import('../views/AboutUS/cooperation.vue')
  },
  {
    path: '/AboutUS/recruit',
    name: 'AboutUSrecruit',
    component: () => import('../views/AboutUS/recruit.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service/index.vue')
  }
]
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
  routes
})

export default router
